import React, { useState, useEffect, useContext } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { LocalizationContext } from '../App';

const LoupeDialogComponent = (props) =>{
    
    const localePath = props.localePath;
    const [open, setOpen] = React.useState(props.show);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return(
        <LocalizationContext.Consumer>
            { ({strings}) => 
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                {strings.getString(`${localePath}.title`)}
                </DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                {strings.getString(`${localePath}.message`)}
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    OK
                </Button>
                </DialogActions>
            </Dialog>
        }
        </LocalizationContext.Consumer>
    );
}
  
export default LoupeDialogComponent;